import React, { FC, useState, useEffect, memo } from "../../../lib/teact/teact";
import { tienFormat } from "../utils/NumberUtils";
import './one789.scss'
import { OneMapBetType, OneProfile, TicketData } from "./oneTypes";
type OwnProps = {
    oneProfile: OneProfile
}

const One789Info: FC<OwnProps> = ({
    oneProfile
}) => {
    /* function mockup() {
        const ret: any = []
        for (let i = 0; i < 100; i++) {
            ret.push(i)
        }
        return ret.join(',');
    } */
    return <div className=" one-profile">
        <div>
            <span>{oneProfile.profile.Username} : </span>

            <span>{tienFormat(oneProfile.profile.Balance)} </span>
            <span>/ {tienFormat(oneProfile.profile.CreditLimit)}</span>

        </div>
        {oneProfile.recentBets.map((item: TicketData, index: number) => {
            return <div className="one-card">
                <div className="one-card-header">
                    <span className="one-card-stt">{oneProfile.recentBets.length - index}</span>
                    <span className="one-type">{OneMapBetType.get(item.BetType)}</span>
                    <span className="one-money">Điểm {tienFormat(item.Point)}</span>
                    <span className="one-money">Tiền {tienFormat(item.Amount)}</span>
                </div>
                <div className="one-card-content">
                    {item.Numbers.join(',')}
                    {/* {
                        mockup()
                    } */}
                </div>
            </div>
        })}
    </div>
}

export default memo(One789Info);